const AllTaskBoard = () => import("./views/AllTaskBoard.vue");
const ViewTaskBoard = () => import("./views/ViewTaskBoard.vue");
const AllTaskProjects = () => import("./views/AllTaskProjects.vue");
const AllArchievedProjects = () => import("./views/AllArchievedProjects.vue");
const CreateTaskProjects = () => import("./views/CreateTaskProjects.vue");
const ViewTaskProjects = () => import("./views/ViewTaskProjects.vue");
const Settings = () => import("./views/Settings.vue");
const SettingsTaskManagement = () =>
  import("./views/SettingsTaskManagement.vue");

const AllApprovers = () =>
  import("@/components/general/approvals/AllApprovers.vue");
const AssignEmployeesAsApprovers = () =>
  import("@/components/general/approvals/AssignEmployeeToApprover.vue");
const ViewApprovers = () =>
  import("@/components/general/approvals/ViewApprovers.vue");
const CreateApprover = () =>
  import("@/components/general/approvals/CreateApprovers.vue");

export default [
  {
    path: "task-board",
    component: AllTaskBoard,
  },
  {
    path: "view-task-board/:id",
    component: ViewTaskBoard,
  },
  {
    path: "all-archieve",
    component: AllArchievedProjects,
  },
  {
    path: "all-projects",
    component: AllTaskProjects,
  },
  {
    path: "create-projects",
    component: CreateTaskProjects,
  },
  {
    path: "view-projects/:id",
    component: ViewTaskProjects,
  },
  {
    path: "edit-projects/:id",
    component: CreateTaskProjects,
  },
  {
    path: "settings",
    component: Settings,
  },
  {
    path: "settings/manage-task-settings",
    component: SettingsTaskManagement,
  },
  {
    path: "settings/manage-approval-settings",
    component: CreateTaskProjects,
  },
  {
    path: "settings/approvers",
    component: AllApprovers,
  },
  {
    path: "settings/approvers/assign/:id",
    component: AssignEmployeesAsApprovers,
  },
  {
    path: "settings/approvers/edit/:id",
    component: CreateApprover,
  },
  {
    path: "settings/approvers/view/:id",
    component: ViewApprovers,
  },
  {
    path: "settings/approvers/create",
    component: CreateApprover,
  },
];
